module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00687.a4ec3274.jpg";